import { IPagination } from 'app/types/common';

export interface IPaymentEventImportsState {
  readonly paymentEventImportsById?: any;
  readonly paymentEventImportIds?: string[];
  readonly hasLoaded?: boolean;
  readonly hasLoaded?: boolean;
  readonly hasSaved?: boolean;
  readonly hasFailed?: boolean;
  readonly isLoading?: boolean;
  readonly isSaving?: boolean;
  readonly selectPaymentEventImportLoading?: boolean;
  readonly hasLoaded?: boolean;
  readonly showAddPaymentEventImport?: boolean;
  readonly requestedData?: any;
  readonly backendErrors?: any;
  readonly organisationPaymentEventImportIds?: string[];
  readonly currentPaymentEventImportId?: string;
  readonly filterConfig?: any;
  readonly sortConfig?: any;
  readonly pagination?: IPagination;
}

export interface IPaymentEventImportsSelector extends IPaymentEventImportsState {
  readonly currentPaymentEventImport?: any;
  readonly currentFormPaymentEventImport?: any;
  readonly paymentEventImportsFilteredByTagInSelectFormat?: any;
  readonly paymentEventImportsByIdInSelectFormat?: any;
  readonly paymentEventImportsFilteredByOrganisationInSelectFormat?: any;
}

export enum PaymentEventImportsActionTypes {
  GET_ALL_PAYMENT_EVENT_IMPORTS_REQUESTED = 'redux-app/payment-event-imports/GET_ALL_PAYMENT_EVENT_IMPORTS_REQUESTED',
  GET_ALL_PAYMENT_EVENT_IMPORTS_PENDING = 'redux-app/payment-event-imports/GET_ALL_PAYMENT_EVENT_IMPORTS_PENDING',
  GET_ALL_PAYMENT_EVENT_IMPORTS_SUCCESS = 'redux-app/payment-event-imports/GET_ALL_PAYMENT_EVENT_IMPORTS_SUCCESS',
  GET_ALL_PAYMENT_EVENT_IMPORTS_FAIL = 'redux-app/payment-event-imports/GET_ALL_PAYMENT_EVENT_IMPORTS_FAIL',
  GET_PAYMENT_EVENT_IMPORT_REQUESTED = 'redux-app/payment-event-imports/GET_PAYMENT_EVENT_IMPORT_REQUESTED',
  GET_PAYMENT_EVENT_IMPORT_PENDING = 'redux-app/payment-event-imports/GET_PAYMENT_EVENT_IMPORT_PENDING',
  GET_PAYMENT_EVENT_IMPORT_SUCCESS = 'redux-app/payment-event-imports/GET_PAYMENT_EVENT_IMPORT_SUCCESS',
  GET_PAYMENT_EVENT_IMPORT_FAIL = 'redux-app/payment-event-imports/GET_PAYMENT_EVENT_IMPORT_FAIL',
  UPDATE_PAYMENT_EVENT_IMPORT_REQUESTED = 'redux-app/payment-event-imports/UPDATE_PAYMENT_EVENT_IMPORT_REQUESTED',
  UPDATE_PAYMENT_EVENT_IMPORT_PENDING = 'redux-app/payment-event-imports/UPDATE_PAYMENT_EVENT_IMPORT_PENDING',
  UPDATE_PAYMENT_EVENT_IMPORT_SUCCESS = 'redux-app/payment-event-imports/UPDATE_PAYMENT_EVENT_IMPORT_SUCCESS',
  UPDATE_PAYMENT_EVENT_IMPORT_FAIL = 'redux-app/payment-event-imports/UPDATE_PAYMENT_EVENT_IMPORT_FAIL',
  CREATE_PAYMENT_EVENT_IMPORT_REQUESTED = 'redux-app/payment-event-imports/CREATE_PAYMENT_EVENT_IMPORT_REQUESTED',
  CREATE_PAYMENT_EVENT_IMPORT_PENDING = 'redux-app/payment-event-imports/CREATE_PAYMENT_EVENT_IMPORT_PENDING',
  CREATE_PAYMENT_EVENT_IMPORT_SUCCESS = 'redux-app/payment-event-imports/CREATE_PAYMENT_EVENT_IMPORT_SUCCESS',
  CREATE_PAYMENT_EVENT_IMPORT_FAIL = 'redux-app/payment-event-imports/CREATE_PAYMENT_EVENT_IMPORT_FAIL',
  DELETE_PAYMENT_EVENT_IMPORT_REQUESTED = 'redux-app/payment-event-imports/DELETE_PAYMENT_EVENT_IMPORT_REQUESTED',
  DELETE_PAYMENT_EVENT_IMPORT_PENDING = 'redux-app/payment-event-imports/DELETE_PAYMENT_EVENT_IMPORT_PENDING',
  DELETE_PAYMENT_EVENT_IMPORT_SUCCESS = 'redux-app/payment-event-imports/DELETE_PAYMENT_EVENT_IMPORT_SUCCESS',
  DELETE_PAYMENT_EVENT_IMPORT_FAIL = 'redux-app/payment-event-imports/DELETE_PAYMENT_EVENT_IMPORT_FAIL',
  SELECT_PAYMENT_EVENT_IMPORT_REQUESTED = 'redux-app/payment-event-imports/SELECT_PAYMENT_EVENT_IMPORT_REQUESTED',
}

export default null;
